import { message } from "antd";
import axiosInstance from "../axiosInstance";
import { PAGE_SIZE } from "../constants";

import {
	CREATE_MOBILE_VERSION_REQUEST,
	CREATE_MOBILE_VERSION_SUCCESS,
	CREATE_MOBILE_VERSION_FAIL,
	RESET_CATEGORIES,
	FETCH_MOBILE_VERSIONS_REQUEST,
	FETCH_MOBILE_VERSIONS_SUCCESS,
	FETCH_MOBILE_VERSIONS_FAIL,
	UPDATE_MOBILE_VERSION_REQUEST,
	UPDATE_MOBILE_VERSION_SUCCESS,
	UPDATE_MOBILE_VERSION_FAIL,
	DELETE_MOBILE_VERSION_REQUEST,
	DELETE_MOBILE_VERSION_SUCCESS,
	DELETE_MOBILE_VERSION_FAIL,
} from "../constants/mobileVersion";

const createMobileVersion = (values) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	dispatch({ type: CREATE_MOBILE_VERSION_REQUEST });
	try {
		const { data } = await axiosInstance.post(
			"/admin/mobile-versions",
			values,
			{
				headers: {
					Authorization: "Bearer " + adminInfo.authToken,
				},
			},
		);
		message.success("Created.");
		dispatch(fetchMobileVersions({ start: 0, count: PAGE_SIZE }));
		dispatch({
			type: CREATE_MOBILE_VERSION_SUCCESS,
			payload: data,
		});
	} catch (error) {
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: CREATE_MOBILE_VERSION_FAIL, payload: errorMessage });
	}
};

const fetchMobileVersions = (params) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();

	dispatch({ type: FETCH_MOBILE_VERSIONS_REQUEST });
	try {
		const { data } = await axiosInstance.get("/admin/mobile-versions", {
			params,
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});

		dispatch({
			type: FETCH_MOBILE_VERSIONS_SUCCESS,
			payload: data,
		});
	} catch (error) {
		console.log("error: ", error);
		const errorMessage = error.response.data.error;
		dispatch({ type: FETCH_MOBILE_VERSIONS_FAIL, payload: errorMessage });
	}
};

const resetCategories = () => async (dispatch) => {
	dispatch({ type: RESET_CATEGORIES });
};

const updateMobileVersion = (id, values) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	dispatch({ type: UPDATE_MOBILE_VERSION_REQUEST });
	try {
		const { data } = await axiosInstance.patch(
			`/admin/mobile-versions/${id}`,
			values,
			{
				headers: {
					Authorization: "Bearer " + adminInfo.authToken,
				},
			},
		);

		message.success("Updated.");
		dispatch({
			type: UPDATE_MOBILE_VERSION_SUCCESS,
			payload: data,
		});
	} catch (error) {
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: UPDATE_MOBILE_VERSION_FAIL, payload: errorMessage });
	}
};

const deleteMobileVersion = (id) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	dispatch({ type: DELETE_MOBILE_VERSION_REQUEST });
	try {
		const { data } = await axiosInstance.delete(
			`/admin/mobile-versions/${id}`,
			{
				headers: {
					Authorization: "Bearer " + adminInfo.authToken,
				},
			},
		);

		message.success("Deleted.");
		dispatch({
			type: DELETE_MOBILE_VERSION_SUCCESS,
			payload: data,
		});
	} catch (error) {
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: DELETE_MOBILE_VERSION_FAIL, payload: errorMessage });
	}
};

export {
	createMobileVersion,
	resetCategories,
	fetchMobileVersions,
	updateMobileVersion,
	deleteMobileVersion,
};
